
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.53 5.65l6.66 3.59a1.91 1.91 0 001.61 0l6.67-3.58c.43-.23.85-1 0-1h-15c-.79.03-.38.76.06.99zm15.13 1.78L10.81 11a1.52 1.52 0 01-.81.18 1.52 1.52 0 01-.81-.18L2.34 7.43C2 7.25 2 7.46 2 7.63v6.52a1 1 0 00.88.85h14.24a1 1 0 00.88-.85V7.63c0-.17 0-.38-.34-.2z"}})])
          )
        }
      }
    